import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_left_outlined",
  "use": "icon-icon_left_outlined-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_left_outlined\">\r\n<path d=\"M6.36341 10.0001L13.1398 16.7765C13.3026 16.9392 13.3026 17.2031 13.1398 17.3658L12.5506 17.955C12.3879 18.1178 12.1241 18.1178 11.9613 17.955L4.59564 10.5893C4.2702 10.2639 4.2702 9.73627 4.59564 9.41083L11.9613 2.04513C12.1241 1.88242 12.3879 1.88242 12.5506 2.04513L13.1398 2.63439C13.3026 2.79711 13.3026 3.06093 13.1398 3.22365L6.36341 10.0001Z\" fill=\"#1F2329\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol